/* eslint-disable no-unused-vars */
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import _ from "lodash";
import { Grid, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
const useStyles = makeStyles(styles);

export default function TerminalInfo() {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [data, setData] = useState([]);

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    try {
      const { data } = await API.post("/report/analytics", {
        template: "reports/analytics/dashboard/terminal_info",
      });

      setData(data);
    } catch (e) {
      console.error(e);
    }
  }
  const options = {
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: false,
    isRowSelectable: false,
    serverSide: true,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    pagination: false,
  };
  const columns = [
    {
      name: "name",
      label: translate("Terminal"),
      display: "true",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Grid container>
              <Grid item xs={2}>
                {!tableMeta.tableData[tableMeta.rowIndex].androidApp && (
                  <DesktopWindowsIcon></DesktopWindowsIcon>
                )}
                {tableMeta.tableData[tableMeta.rowIndex].androidApp && (
                  <PhoneAndroidIcon></PhoneAndroidIcon>
                )}
              </Grid>
              <Grid item xs={10}>
                {tableMeta.tableData[tableMeta.rowIndex].name}
              </Grid>
            </Grid>
          );
        },
      },
    },
    {
      name: "dayOpenStatus",
      label: translate("Day "),
      display: "true",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "user",
      label: translate("User"),
      display: "true",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "noInvoices",
      label: translate("#Invoices"),
      display: "true",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "timeElapsed",
      label: translate("Last Sale"),
      display: "true",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom component="div">
          Terminals
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <MUIDataTable data={data} columns={columns} options={options} />
      </Grid>
    </Grid>
  );
}
